<button  #button title="{{ 'TOOLTIPS.MAS_OPCIONES' | translate }}" igxButton="fab" [igxToggleAction]="opciones" [overlaySettings]="overlaySettingsLeftRightBottom"
  [igxDropDownItemNavigation]="opciones">
  <igx-icon>more_vert</igx-icon>
</button>
<igx-drop-down #opciones (selectionChanging)="onSelectionDropDown($event.newSelection.value)">
  @for (btn of btnsGrid; track btn) {
    <igx-drop-down-item [value]="btn.text">
      <igx-icon igxPrefix>{{btn.icon}}</igx-icon>
      {{ btn.text | translate }}
    </igx-drop-down-item>
  }
</igx-drop-down>
